import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBasements } from '../features/basements/basementsSlice'
import { sendPageView } from '../gtmUtils'
import Spinner from '../components/Spinner'

function Basement() {
	const dispatch = useDispatch()

	const { basements, isLoading, isSuccess } = useSelector((state) => state.basements)

	useEffect(() => {
		sendPageView()
		dispatch(getBasements())
	}, [dispatch])

	return (
		<>
			{isLoading || !isSuccess ? (
				<Spinner />
			) : (
				<div className='container'>
					<div className='basement'>
						<h1 className='large'>Basement Renovations</h1>
						<p className='lead'>
							Specializing in many different basement renovations from adding a room to finishing an
							unfinished basement.
						</p>
						<p className='lead'>
							This includes insulation, framing, drywall, ceilings, door installations, and
							trim/baseboards.
						</p>

						<p className='large'>Previous Projects</p>
						<div className='projects-grid'>
							<div className='project'>
								<h3>
									Finished Basement starting from completely unfinished. A Family Room, Bedroom with
									walk-in closet, and Bathroom were created.
								</h3>

								<p>Before</p>
								<div className='project-grid'>
									{basements[0].before.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>Framing</p>
								<div className='project-grid'>
									{basements[0].framing.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>Drywall</p>
								<div className='project-grid'>
									{basements[0].drywall.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>Finished after painting, flooring, doors and trim installaton</p>
								<div className='project-grid'>
									{basements[0].finished.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>Completed and furnished</p>
								<div className='project-grid'>
									{basements[0].furnished.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>
								<p className='bg-primary'>Testimonial</p>
								<p>
									We used Sproxton General Contracting for a complete basement renovation, from
									intial framing through to drywall and including painting, flooring, doors, and
									trim - and pretty well evertything else that could be included.{' '}
								</p>
								<p>
									{' '}
									Paul's quote was fair and reasonable and he was very accommodating as to payment
									terms and payment time. Paul was always on time, being very punctual and always
									giving us advanced notice of arrival times. especially if he might have been
									delayed, which didn't happen very often.{' '}
								</p>
								<p>
									{' '}
									Paul was very open to giving us his expert opinion on design elements or
									discussing structural issues and options to consider which was especially helpful
									as we had a couple of bulkheads which may have been problematic in other
									formats.{' '}
								</p>
								<p>
									<strong>
										We would heartily recommend Sproxton General Contracting if you were looking to
										get your basement upgraded or fully renovated.
									</strong>{' '}
								</p>
								<p>Mark & Lorraine</p>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default Basement
